import React, { useEffect, useRef, useState, } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import MolGrid from "../../components/Grid/MolGrid";
import Buttons from "../../components/ui/button/Buttons";
import { CertificateIssuanceConfig } from "./data/CertificateIssuanceConfig";
import { CertificateIssuanceFormData } from "./data/CertificateIssuanceForm.data";
import { useLazyGetDropDownsForProductsAndServicesQuery } from "../../app/services/productAndService/productAndServiceApi";
import { useGetSGBPSCertificateIssuanceListMutation } from "../../app/services/CertificateGrouping/certificateGroupingApi";
import { setAllDropDownField } from "./Utils/setFieldParameter";
import DataLoader from "../../components/ui/dataLoader/DataLoader";
import IssueModel from "./components/IssueModel";
import { encryptAESID } from "../../utils/Encryption";

const CertificateIssuanceList = () => {
  const constCertificateIssuanceRef = useRef();
  const molGridRef = useRef();
  const [showIssueModal, setShowIssueModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [formData, setFormData] = useState(CertificateIssuanceFormData);
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 10,
    CompanyCertNumber: null,
    StatusId: 0,
    totalCount: 0,
  });

  const [productsAndServicesDropdown, { data: productsAndServicesDropDownsData, isLoading: productsAndServicesDropDownsLoading }] = useLazyGetDropDownsForProductsAndServicesQuery();
  const [getCertificateList, { isLoading: certificateListLoading, isSuccess: certificateListSuccess, data: certificateListData }] = useGetSGBPSCertificateIssuanceListMutation()



  const handleSearch = () => {
    const taskListFormData = constCertificateIssuanceRef?.current?.getFormData();
    const updatedPaginationRequest = {
      pageNo: 1,
      pageSize: 10,
      CompanyCertNumber: taskListFormData?.companyCertNumber || null,
      StatusId: taskListFormData?.statusId?.value || 0,
    };
    setPaginationRequest(updatedPaginationRequest);
    getCertificateList(updatedPaginationRequest);
  };

  const handleClearClick = () => {
    const updatedFormData = { ...formData };
    updatedFormData.initialState = {
      CompanyCertNumber: null,
      StatusId: 0,
    };

    const request = {
      pageNo: 1,
      pageSize: 10,
      CompanyCertNumber: null,
      StatusId: 0,
      totalCount: 0,
    };

    getCertificateList(request);
    setFormData(updatedFormData);
    setPaginationRequest(request);
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getCertificateList(updatedPaginationRequest);
  };

  useEffect(() => {
    productsAndServicesDropdown();
    getCertificateList(paginationRequest);
  }, []);

  useEffect(() => {
    if (!certificateListLoading && certificateListSuccess && certificateListData) {
      setPaginationRequest(prev => ({ ...prev, totalCount: certificateListData?.totalCount }));
      let taskList = certificateListData?.itemList?.map((item) => {
        return {
          ...item,
          isPeerReviewer: item?.muaStatus == "Confirmed" && item?.paymentStatus == "Paid" && item?.status == "Approved" ? false : true,
          amount: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", }).format(Number(item?.invoiceAmount)),
          membershipTaskListLink: `/viewCorporateMember/${encodeURIComponent(encryptAESID(item?.sgbcCorporateMemberId))}`,
        }
      })
      setDataSource(taskList);
    }
  }, [certificateListLoading, certificateListSuccess, certificateListData]);

  useEffect(() => {
    if (!productsAndServicesDropDownsLoading && productsAndServicesDropDownsData) {
      setAllDropDownField(productsAndServicesDropDownsData);
    }
  }, [productsAndServicesDropDownsLoading, productsAndServicesDropDownsData]);

  const handleIssueClick = (data) => {
    setShowIssueModal(true);
    setSelectedRow(data);
  };

  const closeIssueModal = () => {
    setShowIssueModal(false);
    setSelectedRow(null);
  };  

  const actionHandler = {
    "Issue": handleIssueClick,
  }

  if (productsAndServicesDropDownsLoading || certificateListLoading) {
    return <DataLoader />;
  }

  return (
    <>
      <div className="certificate-issuance">
        <div className="payment-update-filter row">
          <div className="status-input col-9">
            {productsAndServicesDropDownsData &&
              <FormCreator
                ref={constCertificateIssuanceRef}
                {...formData}
              />
            }
          </div>
          <div className="col-3 xero-right-side-btn mt-2 ">
            <div className="d-flex gap-2">
              <Buttons
                buttonText="Search"
                buttonTypeClassName="success-btn "
                onClick={handleSearch}
              />
              <Buttons
                buttonText="Clear"
                buttonTypeClassName="btn btn-secondary"
                onClick={handleClearClick}
              />
            </div>
          </div>
        </div>
        <div className="payment-update-list certificate-issuance-table">
          <MolGrid
            ref={molGridRef}
            configuration={CertificateIssuanceConfig}
            allowPagination={true}
            dataSource={dataSource}
            isLoading={certificateListLoading || productsAndServicesDropDownsLoading}
            pagination={paginationRequest}
            onPageChange={handlePageChange}
            onActionChange={actionHandler}
          />
        </div>
        {showIssueModal && <IssueModel
          closeIssueModal={closeIssueModal}
          showIssueModal={showIssueModal}
          rowData={selectedRow}
          fetchData={() => handleClearClick()}
        />}
      </div>
    </>
  );
};
export default CertificateIssuanceList;
